import React, { useMemo, useState } from "react";
import { useCart } from "../context/CartContextCliente";
import { FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { trackCheckoutClick, trackWhatsappClick } from "../services/analyticsService";

export default function CarritoCliente({
  onClose,
  empresaId,
  empresaSlug,
  telefono,
  empresaNombre,
}) {
  const { cart, removeFromCart, clearCart, incrementItem, decrementItem } = useCart();
  const [nombreCliente, setNombreCliente] = useState("");
  const [tipoEntrega, setTipoEntrega] = useState("retiro");
  const [calle, setCalle] = useState("");
  const [barrio, setBarrio] = useState("");
  const [referencia, setReferencia] = useState("");
  const [franjaHoraria, setFranjaHoraria] = useState("");
  const [medioPago, setMedioPago] = useState("efectivo");

  const total = useMemo(
    () => cart.reduce((sum, item) => sum + Number(item.precio || 0) * Number(item.cantidad || 0), 0),
    [cart]
  );

  const finalizarPedido = () => {
    const esEnvio = tipoEntrega === "envio";
    if (cart.length === 0 || !nombreCliente.trim()) return;
    if (esEnvio && (!calle.trim() || !barrio.trim() || !referencia.trim() || !franjaHoraria.trim())) {
      Swal.fire({
        icon: "warning",
        title: "Faltan datos de envio",
        text: "Completá calle, barrio, referencia y franja horaria para continuar.",
      });
      return;
    }

    let mensaje = `Hola ${empresaNombre}, mi nombre es ${nombreCliente} y necesito estos productos:\n\n`;
    cart.forEach((item) => {
      mensaje += `- ${item.cantidad} x ${item.nombre} ($${item.precio})`;
      if (item.talle) mensaje += ` - Medida: ${item.talle}`;
      mensaje += `\n`;
    });
    mensaje += `\nTipo de entrega: ${esEnvio ? "Envio" : "Retiro"}`;
    if (esEnvio) {
      mensaje += `\nCalle: ${calle}`;
      mensaje += `\nBarrio: ${barrio}`;
      mensaje += `\nReferencia: ${referencia}`;
      mensaje += `\nFranja horaria: ${franjaHoraria}`;
    }
    mensaje += `\nMedio de pago: ${medioPago === "transferencia" ? "Transferencia" : "Efectivo"}`;
    if (medioPago === "transferencia") {
      mensaje += `\nPago con transferencia. Quedo a la espera de los datos para transferir.`;
    }
    mensaje += `\nTotal: $${total}`;

    const url = `https://wa.me/${telefono}?text=${encodeURIComponent(mensaje)}`;

    trackWhatsappClick({
      empresaId,
      empresaSlug,
    }).catch((error) => {
      console.warn("No se pudo registrar el click de WhatsApp:", error);
    });

    trackCheckoutClick({
      empresaId,
      empresaSlug,
      total,
      items: cart,
      customerName: nombreCliente.trim(),
      deliveryMethod: tipoEntrega,
      address: esEnvio ? calle.trim() : null,
      neighborhood: esEnvio ? barrio.trim() : null,
      reference: esEnvio ? referencia.trim() : null,
      paymentMethod: medioPago,
    }).catch((error) => {
      console.warn("No se pudo registrar el cierre de pedido:", error);
    });

    window.open(url, "_blank", "noopener,noreferrer");

    clearCart();
    onClose();
  };

  const handleVaciarCarrito = () => {
    Swal.fire({
      title: "¿Vaciar carrito?",
      text: "Se eliminarán todos los productos agregados",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Sí, vaciar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        clearCart();
        Swal.fire({
          icon: "success",
          title: "Carrito vaciado",
          showConfirmButton: false,
          timer: 1000,
        });
      }
    });
  };

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex"
      style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1200 }}
      onClick={onClose}
    >
      {/* Panel lateral */}
      <div
        className="bg-white shadow p-3 ms-auto"
        style={{ width: "350px", height: "100vh", overflowY: "auto" }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Carrito</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={onClose}>
            Cerrar
          </button>
        </div>

        {cart.length === 0 ? (
          <p>No hay productos en el carrito.</p>
        ) : (
          <>
            <ul className="list-group mb-3">
              {cart.map((item) => (
                <li
                  key={item.id}
                  className="list-group-item d-flex justify-content-between align-items-center"
                >
                  <div style={{ minWidth: 0 }}>
                    <div className="fw-semibold" style={{ lineHeight: 1.15 }}>
                      {item.nombre}
                    </div>

                    {item.talle && (
                      <div>
                        <small className="text-muted">Medida: {item.talle}</small>
                      </div>
                    )}

                    <small className="d-block text-muted">
                      ${item.precio} c/u
                    </small>

                    {/* ✅ Controles de cantidad */}
                    <div className="d-flex align-items-center gap-2 mt-2">
                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm"
                        onClick={() =>
  decrementItem({
    ...item,
    talle: item.talle || "",
    precio: Number(item.precio || 0),
  })
}
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: 999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 900,
                          lineHeight: 1,
                        }}
                        aria-label="Disminuir cantidad"
                        title="Quitar 1"
                      >
                        −
                      </button>

                      <div
                        className="text-center"
                        style={{
                          minWidth: 34,
                          fontWeight: 800,
                          userSelect: "none",
                        }}
                      >
                        {item.cantidad}
                      </div>

                      <button
                        type="button"
                        className="btn btn-dark btn-sm"
                        onClick={() =>
  incrementItem({
    ...item,
    talle: item.talle || "",
    precio: Number(item.precio || 0),
  })
}
                        style={{
                          width: 34,
                          height: 34,
                          borderRadius: 999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 900,
                          lineHeight: 1,
                        }}
                        aria-label="Aumentar cantidad"
                        title="Agregar 1"
                      >
                        +
                      </button>
                    </div>
                  </div>

                  <div className="d-flex flex-column align-items-end gap-2">
                    <div className="fw-bold">
                      ${Number(item.precio || 0) * Number(item.cantidad || 0)}
                    </div>

                    <button
                      className="btn btn-sm btn-outline-danger"
                     onClick={() => removeFromCart(item.id, item.talle || "")}
                      title="Eliminar producto"
                      aria-label="Eliminar producto"
                    >
                      <FaTrash />
                    </button>
                  </div>
                </li>
              ))}
            </ul>

            {/* Nombre del cliente */}
            <div className="mb-3">
              <label className="form-label">Tu nombre</label>
              <input
                type="text"
                className="form-control"
                value={nombreCliente}
                onChange={(e) => setNombreCliente(e.target.value)}
                placeholder="Escribí tu nombre"
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Entrega</label>
              <select
                className="form-select"
                value={tipoEntrega}
                onChange={(e) => setTipoEntrega(e.target.value)}
              >
                <option value="retiro">Retiro</option>
                <option value="envio">Envio</option>
              </select>
            </div>

            {tipoEntrega === "envio" && (
              <>
                <div className="mb-3">
                  <label className="form-label">Calle</label>
                  <input
                    type="text"
                    className="form-control"
                    value={calle}
                    onChange={(e) => setCalle(e.target.value)}
                    placeholder="Ej: San Martin 123"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Barrio</label>
                  <input
                    type="text"
                    className="form-control"
                    value={barrio}
                    onChange={(e) => setBarrio(e.target.value)}
                    placeholder="Ej: Centro"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Referencia</label>
                  <input
                    type="text"
                    className="form-control"
                    value={referencia}
                    onChange={(e) => setReferencia(e.target.value)}
                    placeholder="Ej: porton negro, casa esquina"
                  />
                </div>

                <div className="mb-3">
                  <label className="form-label">Franja horaria (franja de 3 hs)</label>
                  <input
                    type="text"
                    className="form-control"
                    value={franjaHoraria}
                    onChange={(e) => setFranjaHoraria(e.target.value)}
                    placeholder="Ej: 9 a 13 hs"
                  />
                </div>
              </>
            )}

            <div className="mb-3">
              <label className="form-label">Medio de pago</label>
              <select
                className="form-select"
                value={medioPago}
                onChange={(e) => setMedioPago(e.target.value)}
              >
                <option value="efectivo">Efectivo</option>
                <option value="transferencia">Transferencia</option>
              </select>
              {medioPago === "transferencia" && (
                <div className="form-text">
                  Al finalizar se avisará por WhatsApp que el pago será con transferencia.
                </div>
              )}
            </div>

            <h6 className="fw-bold">Total: ${total}</h6>

            <button
              className="btn btn-success w-100 mb-2"
              onClick={finalizarPedido}
              disabled={!nombreCliente.trim()}
            >
              Finalizar compra
            </button>
            <button className="btn btn-outline-danger w-100" onClick={handleVaciarCarrito}>
              Vaciar carrito
            </button>
          </>
        )}
      </div>
    </div>
  );
}
